import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = React.forwardRef(({ children, ...props }, ref) => {
  React.useEffect(() => {
    const handleForceClose = () => {
      // Force close any open tooltips
      const tooltipContent = document.querySelector("[data-radix-tooltip-content]");
      if (tooltipContent) {
        tooltipContent.style.display = "none";
        tooltipContent.style.opacity = "0";
        tooltipContent.style.pointerEvents = "none";

        // Remove from DOM after a short delay
        setTimeout(() => {
          if (tooltipContent.parentNode) {
            tooltipContent.parentNode.removeChild(tooltipContent);
          }
        }, 100);
      }
    };

    window.addEventListener("force-close-tooltips", handleForceClose);
    return () => window.removeEventListener("force-close-tooltips", handleForceClose);
  }, []);

  return (
    <TooltipPrimitive.Root ref={ref} {...props}>
      {children}
    </TooltipPrimitive.Root>
  );
});
Tooltip.displayName = "Tooltip";

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        "z-50 overflow-hidden rounded-md bg-black px-3 py-1.5 text-xs text-white animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
